/**
 * Autonomous Campaign — masked-token encoding (pure leaf util).
 *
 * The single source of truth for compound-index → token encoding, shared by the
 * masked projection (./masking) and the grader-only ./heritageOracle so the two
 * cannot drift. A pure leaf: no imports, no port/masking logic — safe to use
 * from grader code without pulling in the masked-port surface.
 *
 * @module gibbs/autonomousCampaign/workspaces/token
 */

/** Index → token suffix (0→A … 25→Z, 26→AA …); matches /^[A-Z]+$/. */
export function indexToken(index) {
    let n = index;
    let s = '';
    do {
        s = String.fromCharCode(65 + (n % 26)) + s;
        n = Math.floor(n / 26) - 1;
    } while (n >= 0);
    return s;
}
